module.exports = __webpack_public_path__ + "img/ford-bronco-2025.b986481c.png";